import React, {useState} from 'react';
import {Box, Chip, Fade, Grid} from '@mui/material';
import {designSystemToken, Icon} from '@lightricks/react-design-system';

function ManyToManyOptionDisplay({
  options,
  onDelete,
}: {
  options: {id: string; label: string}[];
  onDelete: (option: string) => void;
}) {
  const [exitingChips, setExitingChips] = useState<Record<string, boolean>>({});

  const handleDelete = (optionId: string) => {
    setExitingChips((prev) => ({...prev, [optionId]: true}));

    setTimeout(() => {
      onDelete(optionId);
      setExitingChips((prev) => {
        const newState = {...prev};
        delete newState[optionId];
        return newState;
      });
    }, 300);
  };

  return (
    <Grid
      container
      spacing="6px"
      bgcolor={designSystemToken('semantic.bg.tertiary')}
      border={`1px solid ${designSystemToken('semantic.bg.neutral-inverse')}`}
      borderRadius="8px"
      paddingX="12px"
      paddingY="16px"
      minHeight="120px"
      sx={{
        marginLeft: 0,
        width: '100%',
      }}
    >
      {options.map((option) => (
        <Grid item key={option.id}>
          <Fade in={!exitingChips[option.id]} timeout={300}>
            <Chip
              label={option.label}
              onDelete={() => {
                handleDelete(option.id);
              }}
              deleteIcon={
                <Box>
                  <Icon
                    name="Actions-Close-Small"
                    appearance="white"
                    size="small"
                  />
                </Box>
              }
              sx={{
                backgroundColor: designSystemToken('semantic.bg.inverse'),
                color: designSystemToken('semantic.fg.inverse'),
                padding: '0px 16px 0px 20px',
                borderRadius: '999px',
              }}
            />
          </Fade>
        </Grid>
      ))}
    </Grid>
  );
}

export default ManyToManyOptionDisplay;
